import schema from "./schema.json";

export default {
  schema,
};
